import { gql } from '@/gql/gql';

export const UPDATE_CREDENTIALS_MUTATION = gql(/* GraphQL */ `
  mutation UpdateCredentials($id: ID!, $credentials: JSON!) {
    updateIntegrationCredentialsV2(id: $id, credentials: $credentials) {
      id
      credentials {
        ... on MetaCredentialsModel {
          accessToken
          id
        }
        ... on GA4CredentialsModel {
          measurementId
        }
        ... on KlaviyoCredentialsModel {
          apiKey
        }
        ... on PostscriptCredentialsModel {
          shopToken
        }
        ... on SnapchatCredentialsModel {
          accessToken
          snapchatId
        }
        ... on TikTokCredentialsModel {
          accessToken
          tiktokId
        }
        ... on GoogleAdsCredentialsModel {
          customerId
          merchantId
        }
        ... on SendlaneCredentialsModel {
          apiKey
          integrationToken
        }
        ... on AttentiveCredentialsModel {
          attentiveApiKey
        }
        ... on RedoCredentialsModel {
          redoAccessToken
          redoStoreId
          redoWidgetId
        }
        ... on WebhookCredentialsModel {
          webhookUrl
        }
      }
      oneTimeSigningSecret
    }
  }
`);

export const UPDATE_GOOGLEADS_CREDENTIALS_MUTATION = gql(/* GraphQL */ `
  mutation UpdateGoogleAdsCredentials($id: ID!, $customerId: String!, $merchantId: String!) {
    updateGoogleAdsCredentials(id: $id, customerId: $customerId, merchantId: $merchantId) {
      id
      credentials {
        ... on GoogleAdsCredentials {
          customerId
          merchantId
        }
      }
    }
  }
`);

export const UPDATE_GA4_CREDENTIALS_MUTATION = gql(/* GraphQL */ `
  mutation UpdateGa4Credentials($id: ID!, $measurementId: String!) {
    updateGa4Credentials(id: $id, measurementId: $measurementId) {
      id
      credentials {
        ... on GA4Credentials {
          measurementId
        }
      }
    }
  }
`);

export const UPDATE_INTEGRATION_EVENTS_MUTATION = gql(/* GraphQL */ `
  mutation UpdateIntegrationEvents($id: ID!, $merchantId: String!, $events: [String!]!) {
    updateIntegrationEvents(id: $id, merchantId: $merchantId, events: $events) {
      id
    }
  }
`);

export const UPDATE_INTEGRATION_EVENTS_V2_MUTATION = gql(/* GraphQL */ `
  mutation UpdateIntegrationEventsV2($id: ID!, $events: [String!]!) {
    updateIntegrationEventsV2(id: $id, events: $events) {
      id
    }
  }
`);

export const UPDATE_INTEGRATION_METADATA_MUTATION_V2 = gql(/* GraphQL */ `
  mutation UpdateIntegrationMetadataV2($id: ID!, $metadata: JSON!) {
    updateIntegrationMetadataV2(id: $id, metadata: $metadata) {
      id
      metadata {
        __typename
        ... on MetaMetadataModel {
          contentType
          productIdentifier
          tagDelivery
        }
        ... on GA4MetadataModel {
          productIdentifier
        }
        ... on GoogleAdsMetadataModel {
          contentType
          productIdentifier
          googleAdsCtids {
            ctids
          }
        }
        ... on TikTokMetadataModel {
          contentType
          productIdentifier
          tagDelivery
        }
        ... on SnapchatMetadataModel {
          contentType
          productIdentifier
          tagDelivery
        }
      }
    }
  }
`);

export const UPDATE_INTEGRATION_METADATA_MUTATION = gql(/* GraphQL */ `
  mutation UpdateIntegrationMetadata($id: ID!, $metadata: MetadataInput!) {
    updateIntegrationMetadata(id: $id, metadata: $metadata) {
      id
    }
  }
`);

export const UPDATE_INTEGRATION_PROPERTY_FILTERS_V2_MUTATION = gql(/* GraphQL */ `
  mutation UpdatePropertyFiltersV2($id: ID!, $input: [PropertyFilterInputV2!]!) {
    updatePropertyFiltersV2(id: $id, input: $input) {
      id
    }
  }
`);

export const UPDATE_INTEGRATION_STATUS_V2 = gql(/* GraphQL */ `
  mutation UpdateIntegrationStatusV2($id: ID!, $status: ConnectionStatusV2!) {
    updateIntegrationStatusV2(id: $id, status: $status) {
      id
      status
    }
  }
`);

export const DELETE_INTEGRATION_V2 = gql(/* GraphQL */ `
  mutation DeleteIntegrationV2($id: ID!) {
    deleteIntegrationV2(id: $id)
  }
`);

export const UPDATE_INTEGRATION_CONSENT_MODE_V2_MUTATION = gql(/* GraphQL */ `
  mutation UpdateIntegrationConsentModeV2($id: ID!, $consentMode: Boolean!) {
    updateIntegrationConsentModeV2(id: $id, consentMode: $consentMode) {
      id
      consentMode
    }
  }
`);

export const UPDATE_INTEGRATION_CONSENT_MODE_MUTATION = gql(/* GraphQL */ `
  mutation UpdateIntegrationConsentMode($id: ID!, $consentMode: Boolean!) {
    updateIntegrationConsentMode(id: $id, consentMode: $consentMode) {
      id
    }
  }
`);

export const UPDATE_INTEGRATION_SMART_QUALIFY_V2_MUTATION = gql(/* GraphQL */ `
  mutation UpdateIntegrationSmartQualifyV2($id: ID!, $smartQualify: Boolean!) {
    updateSmartQualifyV2(id: $id, smartQualify: $smartQualify) {
      id
      smartQualify
    }
  }
`);

// Resolves a conversion action per event, creating any the merchant does not
// already have. Recommended mode never asks them to name one, and an upload
// with no conversion action is rejected by Google.
export const GOOGLEADS_ENSURE_CONVERSION_ACTIONS_MUTATION = gql(/* GraphQL */ `
  mutation GoogleAdsEnsureConversionActions($id: ID!, $customerId: String!, $events: [String!]!) {
    googleAdsEnsureConversionActions(id: $id, customerId: $customerId, events: $events) {
      event
      ctid {
        id
        userCreated
        selected
      }
    }
  }
`);
